import { ERRORS_MESSAGE } from "@lhd/constants";
import { Checkbox, Form, Input, InputNumber, Space } from "antd";
import { FC } from "react";

type PropsType = {
  getFieldClassName?: (name: string) => string;
};

const TextEditModal: FC<PropsType> = ({ getFieldClassName }) => {
  return (
    <>
      <Form.Item
        label="フィールド名"
        name="name"
        rules={[{ required: true, message: ERRORS_MESSAGE.REQUIRED }]}
        className={`${getFieldClassName?.("name")}`}
      >
        <Input />
      </Form.Item>
      <Form.Item
        valuePropName="checked"
        name="is_hide_name"
        style={{ marginBottom: "0.5rem" }}
      >
        <Checkbox>フィールド名を表示しない</Checkbox>
      </Form.Item>
      <Form.Item
        valuePropName="checked"
        name="is_required_field"
        style={{ marginBottom: "0.5rem" }}
      >
        <Checkbox>必須項目にする</Checkbox>
      </Form.Item>
      <Form.Item
        valuePropName="checked"
        name="is_prohibit_duplicate_values"
        style={{ marginBottom: "0.5rem" }}
      >
        <Checkbox>重複値を禁止する</Checkbox>
      </Form.Item>
      <div className="number-chars-section">
        <div>文字数（整数で指定）</div>
        <Space direction="horizontal">
          <Form.Item
            name="min_num_char"
            label={<p style={{ fontSize: 12 }}>最小</p>}
          >
            <InputNumber precision={0} min={1} />
          </Form.Item>
          <Form.Item
            name="max_num_char"
            label={<p style={{ fontSize: 12 }}>最大</p>}
          >
            <InputNumber precision={0} min={1} />
          </Form.Item>
        </Space>
      </div>
      <Form.Item name="default_value" label="初期値">
        <Input />
      </Form.Item>
      <Form.Item
        label="フィルードコード"
        name="field_code"
        rules={[{ required: true, message: ERRORS_MESSAGE.REQUIRED }]}
        className={`${getFieldClassName?.("field_code")}`}
      >
        <Input />
      </Form.Item>
    </>
  );
};

export default TextEditModal;
